import { useEffect, useState } from "react";
import { DynamicIcon } from "../../../components/DynamicIcon/DynamicIcon";
import TagService from "../../../services/TagService";
import { useUserStore } from "../../../contexts/userStore";
import { useAuth } from "../../../contexts/auth";
import { useFastCondoUserStore } from "./context";
import { useTranslation } from "react-i18next";
import CondominioService from "../../../services/CondominioService";

export function ProfileStep({ ...props }) {
   const { t } = useTranslation();
   const { user } = useAuth();
   const { selectedCondominio } = useUserStore();
   const [tags, setTags] = useState(null);
   const [isLoading, setIsLoading] = useState(true);
   const { selectedTag, errors, isSubmitting, update } = useFastCondoUserStore();

   async function apiFetchScopeTags() {
      return await CondominioService.listScopeTagsByTypes(selectedCondominio, ['PERSON']);
   }

   async function apiFetchTags() {
      return await TagService.listTagsByClientAndType(user.userData.selectedOrganizationId, 'PERSON');
   }

   async function fetchTags() {
      setIsLoading(true);
      const response = await apiFetchScopeTags();
      if (response.status === 200 && !Array.isArray(response.data)) {
         response = await apiFetchTags();
      }
      try {
         if (response.status === 200 && response.data) {
            const sortedTags = response.data.sort((a, b) => a.name.localeCompare(b.name));
            setTags(
               sortedTags.filter(tag => tag.licensePerson)
            );
         }
      } catch (error) {
         console.log(error);
      }
      setIsLoading(false);
   }

   useEffect(() => {
      fetchTags();
   }, [selectedCondominio]);

   return (
      <div className="flex flex-wrap gap-3 items-center justify-center">
         {isLoading ? (
            <div className="w-[90%]! grid! grid-cols-4 gap-3">
               <div className="shimmer rounded-lg w-full h-22.5"></div>
               <div className="shimmer rounded-lg w-full h-22.5"></div>
               <div className="shimmer rounded-lg w-full h-22.5"></div>
               <div className="shimmer rounded-lg w-full h-22.5"></div>
            </div>
         ) : (
            <div className="w-[90%]! flex flex-col gap-3">
               {errors.selectedTag && errors.selectedTag.length > 0 && (
                  <p className="text-center text-red-500!">
                     {errors.selectedTag.join('. ')}
                  </p>
               )}
               <div className="tag-profile-selector w-full grid! grid-cols-4">
                  {tags?.map(tag => (
                     <div key={tag.externalId}>
                        <input
                           id={tag.externalId}
                           type="radio"
                           name={`tag-${tag.externalId}`}
                           value={tag.externalId}
                           onChange={e => update("selectedTag", e.target.value)}
                           checked={selectedTag === tag.externalId || selectedTag === Number(tag.id)}
                           disabled={isSubmitting}
                           className="peer/tag"
                        />
                        <label htmlFor={tag.externalId} className="w-full! h-[110px]! peer-focus/tag:outline-(--primaryColor) rounded-full peer-focus/tag:outline-2">
                           <DynamicIcon iconName={tag.icon} size={22} />
                           {tag.name}
                        </label>
                     </div>
                  ))}
               </div>
            </div>
         )}
      </div>
   );
}